import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for IntelligenceStore, for use in the registry */ export const IntelligenceStoreActionTypes = [
    ActionType.FetchImageRecommendationsAction,
    ActionType.FetchImageRecommendationsFailedAction,
    ActionType.FetchImageRecommendationsSucceededAction,
    ActionType.CopilotReSyncTilesAction,
    ActionType.AugloopSessionReadyAction
];
